import { Transfer } from '../../lib/types/models/transfer/transfer'
import { TransferInput } from '../../lib/types/models/transfer/transfer-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTransfer(data: TransferInput) {
  return restApiClient
    .url(constructApiUrl(API.transfer.create.url, null))
    .post<Transfer, TransferInput>(data)
}
